import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { Link } from "react-router-dom";
import PropTypes from "prop-types";
import { Table, Input, Space, Col, Row, Popconfirm, Tooltip } from "antd";
import { ReactComponent as Editicon } from "../../image/Editicon.svg";
import { ReactComponent as Archive } from "../../image/Archive.svg";
import { ReactComponent as Archiveicon } from "../../image/Archiveicon.svg";

import SearchIcon from "../../image/SearchIcon.svg";
import pfdLogo from "../../image/pdf.png";
import {
  ErrorNotificationMsg,
  SuccessNotificationMsg,
} from "../../utils/Notifications";
import { debounce } from "lodash";
import { getRequest, postRequest } from "../../axios";
import "antd/dist/antd.min.css";
import "../../styles/Main.scss";
import ButtonField from "../../common/htmlComponents/ButtonField";
import { authUserData } from "../../utils/Helper";

const { Search } = Input;
const VendorDocumentGrid = ({
  refreshGrid,
  onEditIconClick,
  VendorId,
  gstVendorId,
  gstValue,
}) => {
  const { t } = useTranslation();
  const [selectedRow, setSelectedRow] = useState([]);
  const [loading, setLoading] = useState(false);
  const [vendorDocumentList, setVendorDocumentList] = useState([]);
  const [totalCount, settotalCount] = useState(0);
  const [reload, setReload] = useState(false);
  const [state, setState] = useState({
    page: 1,
    ordering: "id",
    pagesize: 10,
    search: "",
    total: 0,
  });
  const CompanyId = authUserData()?.company ? authUserData()?.company : null;
  const vendorAdmin = authUserData()?.vendor
    ? authUserData()?.role[0].name
    : null;
  useEffect(() => {
    const getVendorDocumentList = async () => {
      setLoading(true);
      try {
        let apiResponse;
        if (CompanyId !== null) {
          apiResponse = await getRequest(
            `vendor-document/?company_id=${CompanyId}&vendor_id=${VendorId}`,
            state
          );
        } else {
          apiResponse = await getRequest(
            `vendor-document/?vendor_id=${VendorId}`,
            state
          );
        }

        console.log("api ", apiResponse);
        if (apiResponse.data.results.success === true) {
          console.log("poo");
          console.log(apiResponse);
          setVendorDocumentList(apiResponse.data.results.data);

          settotalCount(apiResponse.data.count);
        }
        setLoading(false);
      } catch (error) {
        setLoading(false);
      }
    };
    const getGstVendorDocumentList = async () => {
      setLoading(true);
      try {
        let apiResponse;
        if (CompanyId !== null) {
          apiResponse = await getRequest(
            `vendor-document/?company_id=${CompanyId}&vendor_id=${gstVendorId}`,
            state
          );
        } else {
          apiResponse = await getRequest(
            `vendor-document/?vendor_id=${gstVendorId}`,
            state
          );
        }

        console.log("api ", apiResponse);
        if (apiResponse.data.results.success === true) {
          setVendorDocumentList(apiResponse.data.results.data);

          settotalCount(apiResponse.data.count);
        }
        setLoading(false);
      } catch (error) {
        setLoading(false);
      }
    };

    // if (VendorId !== null) {
    //   getVendorDocumentList();
    // }
    if (
      (VendorId !== null && gstVendorId === null) ||
      vendorAdmin === "Vendor Admin"
    ) {
      // if (keypersonId !== null) {

      getVendorDocumentList();
    }

    if (gstVendorId !== null && vendorAdmin !== "Vendor Admin") {
      getGstVendorDocumentList();
    }
    if (VendorId === null && gstVendorId === null) {
      setVendorDocumentList([]);
    }
  }, [state, reload, t, refreshGrid, VendorId, gstVendorId]);

  const handleTableChange = async (pagination, filters, sorter, ordering) => {
    const orderBy = GetSortingEnumValue(sorter.columnKey, sorter.order);
    setState({
      ...state,
      page: pagination.current,
      pagesize: pagination.pageSize,
      ordering: orderBy,
    });
  };

  const GetSortingEnumValue = (sortField, sortOrder) => {
    let sortingEnumKey = "id";
    if (sortField === "company" && sortOrder === "ascend") {
      sortingEnumKey = "company";
    }
    if (sortField === "company" && sortOrder === "descend") {
      sortingEnumKey = "-company";
    }
    if (sortField === "document_name" && sortOrder === "ascend") {
      sortingEnumKey = "document_name";
    }
    if (sortField === "document_name" && sortOrder === "descend") {
      sortingEnumKey = "-document_name";
    }
    if (sortField === "document_url" && sortOrder === "ascend") {
      sortingEnumKey = "document_url";
    }
    if (sortField === "document_url" && sortOrder === "descend") {
      sortingEnumKey = "-document_url";
    }

    return sortingEnumKey;
  };

  const searchCallbackDelayed = (event) => {
    const { value } = event.target;
    debounceLoadData(value, onSearch);
  };

  const onSearch = (value) => {
    setState({
      ...state,
      search: value,
    });
  };

  const rowSelection = {
    onChange: (selectedRowKeys) => {
      setSelectedRow(selectedRowKeys);
    },
  };

  const debounceLoadData = debounce((value, onSearch) => {
    onSearch(value);
  }, 1000);

  const handleArchive = async (id = "") => {
    let ids = selectedRow;
    console.log("IDS", ids);
    if (ids.length === 0) {
      ids.push(id);
    }
    try {
      let apiResponse = await postRequest("vendor-document/document-archive/", {
        deleted: ids,
      });
      if (apiResponse.data.success) {
        SuccessNotificationMsg(t("document_archive_successfully"));
        setReload(!reload);
        setSelectedRow([]);
      } else {
        ErrorNotificationMsg(t("error_in_document_archive"));
      }
    } catch (error) {
      // ErrorNotificationMsg(error);
    }
  };

  const handleEditIconClick = (id) => {
    onEditIconClick(id);
  };

  const columns = [
    ...(vendorAdmin !== "Vendor Admin"
      ? []
      : [
          {
            title: "Company",
            dataIndex: "company_name",
            key: "company",
            sorter: true,
          },
        ]),

    {
      title: "Title",
      dataIndex: "document_name",
      key: "document_name",
      sorter: true,
    },
    {
      title: "Document",
      dataIndex: "document_url",
      key: "document_url",
      sorter: true,
      render: (document_url) =>
        document_url && (
          <>
            <a
              style={{ textDecoration: "none", color: "black" }}
              href={`${document_url}`}
              download
              target="_blank"
              rel="noreferrer"
            >
              <img
                src={document_url.endsWith(".pdf") ? pfdLogo : document_url}
                style={{ width: "40px", height: "40px", objectFit: "cover" }}
                alt={
                  document_url.endsWith(".pdf")
                    ? "PDF Logo"
                    : "Document Preview"
                }
              />
            </a>
          </>
        ),
    },

    {
      title: "Action",
      key: "operation",
      fixed: "right",
      width: 150,
      render: (text, record) => (
        <Space>
          <Editicon onClick={() => handleEditIconClick(record.id)} />

          <Popconfirm
            className="action"
            title={t("pop_title")}
            okText={t("pop_ok")}
            cancelText={t("pop_cancel")}
            onConfirm={() => handleArchive(record.id)}
          >
            <Archive style={{ cursor: "pointer" }} />
          </Popconfirm>
        </Space>
      ),
    },
  ];

  return (
    <>
      <section className="grid-sec mt-5">
        {/* <div className="PR-body"> */}
        <Row className="tblheader">
          <Col xs={24} sm={24} md={24} lg={24} xl={24} className="tbl-action">
            <div className="searchwrp">
              <Space direction="vertical">
                <Search
                  prefix={
                    <img
                      src={SearchIcon}
                      alt="SearchIcon"
                      className="SearchIcon"
                      width={22}
                    />
                  }
                  placeholder={t("pl_search_list")}
                  onChange={searchCallbackDelayed}
                  style={{
                    width: 250,
                  }}
                />
              </Space>
            </div>
            {selectedRow.length > 0 && (
              <Popconfirm
                className="action"
                title={t("pop_title")}
                okText={t("pop_ok")}
                cancelText={t("pop_cancel")}
                placement="left"
                onConfirm={() => handleArchive()}
              >
                <ButtonField
                  className="BlueShadowBtn"
                  type="primary"
                  htmlType="button"
                  label={t("pl_archive")}
                />
              </Popconfirm>
            )}
            <Tooltip placement="topLeft" title="Archived Records">
              <Link to={`/vendor-document/archive/${VendorId}`}>
                <Archiveicon />
              </Link>
            </Tooltip>
          </Col>
        </Row>

        <Table
          rowSelection={rowSelection}
          columns={columns}
          rowKey={(record) => record.id}
          dataSource={vendorDocumentList}
          loading={loading}
          pagination={{
            defaultCurrent: state.page,
            defaultPageSize: state.pagesize,
            total: totalCount,
            showTotal: (total) => `Total ${total} items`,
            showSizeChanger: true,
            locale: {
              items_per_page: "Items / Page", // Text for the size changer
            },
          }}
          onChange={handleTableChange}
        />
        {/* </div> */}
      </section>
    </>
  );
};

VendorDocumentGrid.propTypes = {
  refreshGrid: PropTypes.bool,
  onEditIconClick: PropTypes.func,

  VendorId: PropTypes.number,
  // assignsiteId: PropTypes.func,
  // setAssignSiteId: PropTypes.func,
  gstVendorId: PropTypes.number,
  gstValue: PropTypes.number,
};
export default VendorDocumentGrid;
